import { attr, belongsTo, hasMany } from '@ember-data/model';
import ShModel from 'sh-www/models/sh-model';

class CompanyTeam extends ShModel {
  @attr('string') name;
  @attr('string') description;
  @attr('string') colorHex;

  @belongsTo('company', { async: false }) company;
  @hasMany('companyTeamMembership', { async: false }) companyTeamMemberships;
  @hasMany('costCode', { async: false }) costCodes;
  @belongsTo('brand', { async: false }) brand;

  get users() {
    if (!this.companyTeamMemberships) return [];
    return this.companyTeamMemberships.map(({ companyMembership }) => companyMembership.user);
  }
}

export default CompanyTeam;
